module.exports = __webpack_public_path__ + "static/media/regulamento-ana-2020.42db51b6.pdf";